import { Component, Watch, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { IPlayerNotesService } from '@/components/chat/_domain/modules/player-notes-service';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IPlayerNote } from '@/components/chat/_domain/models/player-notes-model';
import { UserSettingsUpdatedEventName } from '@/components/user-settings/_domain/models';
import { format } from 'date-fns';
import { User } from '@/app-modules/store/modules/user';
import { UserChatStatus } from '../chat/_domain/modules/user-chat-status-service/user-chat-status-service-interface';
import AddPlayerNoteComponent from '@/components/player-notes/_components/add-player-note';
import PlayerNoteDetailsComponent from '@/components/player-notes/_components/player-note-details';
import PlayerSearchComponent from '@/components/player-notes/_components/player-search';

@Component({
  name: 'PlayerNotesComponent',
  components: {
    addPlayerNote: AddPlayerNoteComponent,
    playerNoteDetails: PlayerNoteDetailsComponent,
    playerSearch: PlayerSearchComponent
  }
})
export default class PlayerNotesComponent extends TombolaBaseComponent {
  private userPreferences: UserPreferences = null;
  private user: User = null;
  private playerNotesUsername: string = '';
  private playerNotes: IPlayerNote[] = [];
  private playerNote: IPlayerNote = null;
  private isLoading: boolean = false;
  private showAddNote: boolean = false;
  private showNoteDetails: boolean = false;
  private validPlayer: boolean = false;

  @Watch('playerNotesUsername')
  private onPlayerNotesUsernameChanged(value: string): void {
    this.getPlayerNotesByUsernameInStore();
    this.playerNote = null;
  }

  @Watch('showAddNote')
  private onShowAddNoteChanged(value: boolean): void {
    this.getPlayerNotesByUsernameInStore();
  }

  @Watch('showNoteDetails')
  private onShowNoteDetailsChanged(value: boolean): void {
    this.getPlayerNotesByUsernameInStore();
  }

  private async viewNoteInDetail(note: IPlayerNote) {
      this.playerNote = note;
      this.showNoteDetails = true;
  }

  private async deleteNote(noteId: string) {
    this.isLoading = true;
    const noteToDelete = this.playerNotes.find((note) => note.NoteId === noteId);

    const result = await this.playerNotesService.deletePlayerNote(noteToDelete, this.playerNotesUsername);

    if (result) {
      const indexToRemove = this.playerNotes.findIndex((note) => note.NoteId === noteId);

      if (indexToRemove >= 0) {
        this.playerNotes.splice(indexToRemove, 1);
      }
    }

    this.isLoading = false;
  }

  private showAddNewNote(): void {
    this.showAddNote = true;
  }

  private formattedTimeStamp(value: string): string {
    return format(value, 'YYYY-MM-DD HH:mm:ss');
  }

  private allowDeletion(): boolean {
    return this.user.userChatStatus === UserChatStatus.ShiftLeader || this.user.userChatStatus === UserChatStatus.TeamLeader;
  }

  private async getPlayerNotesByUsernameInStore() {
    this.playerNotes = [];
    this.userPreferences = this.$tombolaStore.Get(UserPreferences);
    this.getPlayerNotesUsername();
    if (this.playerNotesUsername !== '') {
      try {
        this.isLoading = true;
        const playerNotesResponse = await this.playerNotesService.getPlayerNotesByUsername(this.playerNotesUsername);
        if (playerNotesResponse) {
          this.playerNotes = playerNotesResponse.NoteSummaries.sort((item1, item2) => ( item1.CreatedDate > item2.CreatedDate ) ? -1 : 1);
        }
        this.validPlayer = true;
      } catch {
        this.playerNotes = [];
        this.validPlayer = false;
      } finally {
        this.isLoading = false;
      }
    } else {
      this.validPlayer = false;
    }
  }

  private async getUserInStore() {
    this.user = this.$tombolaStore.Get(User);
  }

  private get playerNotesService(): IPlayerNotesService{
    return this.$container.get(SERVICE_IDENTIFIERS.IPlayerNotesService);
  }

  protected async beforeMount() {
    this.getUserInStore();
    this.getPlayerNotesByUsernameInStore();
  }

  protected async created() {
    this.$eventbus.$on(UserSettingsUpdatedEventName, this.getPlayerNotesUsername);
  }

  private beforeDestroy(): void {
    this.$eventbus.$off(UserSettingsUpdatedEventName, this.getPlayerNotesUsername);
  }

  private getPlayerNotesUsername() {
    this.playerNotesUsername = this.userPreferences.playerNotesUsername;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/player-notes/player-notes.component.ts